import './header'
import './seatmaps'
import './name-your-seat'

$(() => {
    const promoTag = document.querySelector('.tn-utility-nav-applied-promo__tag');
    if(promoTag) {
        promoTag.setAttribute("viewBox", "0 0 15 30");
    }
})
